import { cloneDeep } from "lodash";
import { setSelectType, transfromGoodsInfo } from "@/utils";
import { v4 as uuidv4 } from "uuid";
import Vue from "vue";

export default {
  state: {
    isAudit: false, // 在小班使用，若为审核状态，则隐藏¥符号
    uniqueId: uuidv4(), // 全局唯一ID，用于埋点记录
    forcedReload: false, // 是否强制刷新页面
    isReload: true, // 是否刷新重新加载接口的标识
    isChangeCourse: "", // 是否在更换课程 main: 主课，increase: 推荐课
    selectAll: false, // 全选按钮状态
    rawHomeData: {}, // 首页原始数据
    rawCheckData: {}, // 计价接口的原始数据，用于拼接下单的参数
    purpose: 0, // 用途 1：常规售卖，2：退费挽留
    priceInfo: {}, // 总金额和优惠金额信息
    originParams: {
      // activityId: "",
      // cardType: "", // increase: 推荐课，main: 主课
      // type:"",
      // ruleConditionId: "",
      // change_product_ids : "",
      // currentId: "",
    }, // 用于更换课程时的参数
    // 状态ID （1、正常状态，2、已报满（无库存），3、已购买，4、已停售，5、需诊断后报名，6、无报名资格，10、诊断未通过，11、待开售）
    indexShowCourseList: {
      // 用于首页展示数据，包括主课和推荐课，时刻保持这个数据最新状态
      // 前端新增selectType: 1：可选，2：已选，3：禁选
      main_list: [], // 主课
      increase_list: [], // 推荐课
    },
    indexHiddenCourseList: {
      // 首页被隐藏的数据
      main_list: [], // 主课
      increase_list: [], // 推荐课
    },
    isChangedIncrease: false, // 推荐课勾选框是否有交互，如果没交互支付时显示推荐课列表弹窗
    increasePopupSelectedIds: [], // 推荐课弹窗中选中的商品ID
    new_ui: false, // 是否使用新UI(点击立即支付按钮时 是否展示加价购弹窗)
  },
  mutations: {
    setIsAudit(state, param) {
      state.isAudit = param;
    },
    setForcedReload(state, param) {
      state.forcedReload = param;
    },
    // 设置是否重新加载接口
    setIsReload(state, param) {
      state.isReload = param;
    },
    setIsChangeCourse(state, param) {
      state.isChangeCourse = param;
    },
    setOriginParams(state, data = {}) {
      state.originParams = data;
    },
    setPurpose(state, val) {
      state.purpose = val;
    },
    // 设置选中态，同时将所有可操作的商品设置为选中态
    setSelectAll(state, bool) {
      state.selectAll = bool;
      const { main_list = [], increase_list = [] } =
        state.indexShowCourseList || {};
      const allList = [...main_list, ...increase_list];
      for (let item of allList) {
        if (item.selectType !== 3) {
          Vue.set(item, "selectType", bool ? 2 : 1);
        }
      }
    },
    setSelectAllByAll(state) {
      const { main_list = [], increase_list = [] } =
        state.indexShowCourseList || {};
      const allList = [...main_list, ...increase_list];
      // 若所有数据都选中，那么设置全选
      // 刨除所有禁选的商品
      const allowAll = allList.filter((item) => item.selectType !== 3);
      state.selectAll =
        allowAll.length > 0 && allowAll.every((item) => item.selectType === 2);
    },
    // 选中/取消选中某个商品
    setSelectOne(state, id) {
      const { main_list = [], increase_list = [] } =
        state.indexShowCourseList || {};
      const allList = [...main_list, ...increase_list];
      for (let item of allList) {
        if (item.id === id && item.selectType !== 3) {
          Vue.set(item, "selectType", item.selectType === 2 ? 1 : 2);
          break;
        }
      }
    },
    // 首页接口返回的原始数据
    setRawHomeData(state, data) {
      state.rawHomeData = cloneDeep(data);
    },
    setRawCheckData(state, data) {
      state.rawCheckData = cloneDeep(data);
    },
    // 每次计价后重置总金额，重置每个商品的金额
    setPriceInfo(state, data = {}) {
      const { promotion_info = {}, price_list = [] } = data;
      state.priceInfo = promotion_info;
      // 重置商品金额
      const { main_list = [], increase_list = [] } =
        state.indexShowCourseList || {};
      const allList = [...main_list, ...increase_list];
      for (let priceItem of price_list) {
        for (let item of allList) {
          if (priceItem.id === item.selection_before_id) {
            if (!item.price) {
              Vue.set(item, "price", {});
            }
            Vue.set(item.price, "final_price", priceItem.sale_price);
            break;
          }
        }
      }
    },
    // 根据type 设置首页的展示与隐藏数据，type: main 展示主课，increase 展示推荐课
    setIndexList(state, { list = [], type = "" }) {
      const show_list = [];
      const hide_list = [];
      for (let item of list) {
        if (item.is_limit === 1) {
          hide_list.push(item);
          if (type === "increase") {
            state.isChangedIncrease = false;
            state.increasePopupSelectedIds = [];
          }
        } else {
          setSelectType(item);
          show_list.push(item);
        }
      }
      if (!state.indexShowCourseList) {
        state.indexShowCourseList = {
          main_list: [], // 主课
          increase_list: [], // 推荐课
        };
      }
      if (!state.indexHiddenCourseList) {
        state.indexHiddenCourseList = {
          main_list: [], // 主课
          increase_list: [], // 推荐课
        };
      }
      if (type === "main") {
        state.indexShowCourseList.main_list = transfromGoodsInfo(
          show_list,
          type
        );
        state.indexHiddenCourseList.main_list = transfromGoodsInfo(
          hide_list,
          type
        );
      } else {
        state.indexShowCourseList.increase_list = transfromGoodsInfo(
          show_list,
          type
        );
        state.indexHiddenCourseList.increase_list = transfromGoodsInfo(
          hide_list,
          type
        );
      }
    },
    // 换为本课时使用
    exchangeIndexShowCourseList(state, newObj) {
      // 根据originParams的currentId  更换掉indexShowCourseList中的课程
      const { currentId, cardType } = state.originParams;
      const { main_list = [], increase_list = [] } = state.indexShowCourseList;
      const finalList = cardType === "main" ? main_list : increase_list;
      finalList.forEach((item, index) => {
        if (item.id === currentId) {
          Vue.set(
            finalList,
            index,
            Object.assign({}, newObj, {
              selectType: item.selectType === 3 ? 1 : item.selectType,
              can_change: 1,
              change_product_ids: item.change_product_ids,
              parent_product_id: item.parent_product_id,
              parent_product_type: item.parent_product_type,
              change_product_type: item.change_product_type,
              rule_condition_id: item.rule_condition_id,
              is_increase: item.is_increase,
            })
          );
          return;
        }
      });
    },
    // 推荐课勾选框有交互
    setIsChangedIncrease(state) {
      state.isChangedIncrease = true;
    },
    setIncreasePopupSelectedIds(state, param) {
      state.increasePopupSelectedIds = param;
    },
    setNewUi(state, param) {
      state.new_ui = param;
    },
  },
  actions: {},
};
